module.exports = __webpack_public_path__ + "static/media/BarlowSemiCondensed-ExtraLight.18c47fd5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/BarlowSemiCondensed-ExtraLight.ttf
// module id = 2883
// module chunks = 51